<script context="module" lang="ts">
  export type DownloadOptions = {
    name: string,
    type: string
  }
</script>
<script lang="ts">
  import { Tooltip } from "sveltestrap";
  import { domId, html } from "~/lib/html";
  export let copy = true
  export let download : boolean | DownloadOptions = false
  export let code = null
  export let height = "auto"

  const defaultDownloadOptions : DownloadOptions = {
    name: "code.txt",
    type: "text/plain"
  }

  const codeId = domId('code')
  const copyId = domId('copy')
  let codeElement = null

  let copySuccessful = false

  function copyToClipboard(){
    window.getSelection().selectAllChildren(codeElement)
    copySuccessful = document.execCommand('copy') // Apparently-deprecated interface returns boolean success indicator
    if(!copySuccessful) return;    
    setTimeout(function(){
      copySuccessful = false
      window.getSelection().removeAllRanges()
    }, 2000)
  }

  function doDownload(){
    const text = codeElement?.textContent;
    if(!text) return;
    const {name,type} = download === true ? defaultDownloadOptions : {...defaultDownloadOptions,...download}
    const blob = new Blob([text], {type});
    // TODO: Refactor below into downloadBlob(blob, name) if you find yourself copying this
    const url = URL.createObjectURL(blob)
    const link = html('a', {href: url, download: name})
    console.log(link)
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
</script>

<div class="code-block" style="height: {height}">
  <code id={codeId} bind:this={codeElement}><slot>{code}</slot></code>
  <div class="button-container">
    {#if copy}
      <button id={copyId} on:click={copyToClipboard} class="btn btn-sm btn-outline btn-primary" type="button"><span class="glyphicon glyphicon-copy"></span></button>
    {/if}
    {#if download}
      <button on:click={doDownload} class="btn btn-sm btn-outline btn-primary" type="button"><span class="glyphicon glyphicon-download"></span> Download</button>
    {/if}
  </div>
</div>
{#if copySuccessful}
  <Tooltip isOpen placement="top" target={codeId}>Copied to clipboard</Tooltip>
{:else if copy}
  <Tooltip placement="top" target={copyId}>Copy to clipboard</Tooltip>
{/if}

<style>
  div.code-block {
    padding: 0.25rem;
    margin: 0 -0.25rem 1rem;
    border-radius: 0.5rem;
    position: relative;
    background: #eee;
  }
  div.button-container {
    position: absolute;
    bottom: 0.35rem;
    right: 0.35rem;
    display: flex;
    justify-content: flex-end;
    gap: 0.2rem;
    pointer-events: none;
  }
  div.code-block button {
    pointer-events: all;
    display: flex;
    align-items: center;
    gap: 0.3rem;
    border-radius: 0.3rem;
  }
  button span {
    position: static;
    line-height: inherit;
  }
  code {
    padding: 0.5rem 0.75rem;
    display: block;
    white-space: pre;
    color: inherit;
    max-height: 100%;
    max-width: 100%;
    overflow: auto;
  }
</style>